// extracted by mini-css-extract-plugin
export default {"loader":"LoaderIcon_loader__4Iy0F","spin":"LoaderIcon_spin__U+fQc"};